import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUrl } from "../apiUrl";

export const getDocumentosByPatientId = createAsyncThunk(
  "documentos/getByPatientId",
  async (patient_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/v1/documentos/patient/${patient_id}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const createDocumento = createAsyncThunk(
  "documentos/create",
  async (nuevoDocumento, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/documentos`,
        nuevoDocumento
      );
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteDocumento = createAsyncThunk(
  "documentos/delete",
  async (documentoId, { rejectWithValue, getState }) => {
    try {
      await axios.delete(`${apiUrl}/api/v1/documentos/${documentoId}`);
      return documentoId;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue(error.message);
    }
  }
);

const documentosSlice = createSlice({
  name: "documentos",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
    currentPatientId: null
  },
  reducers: {
    resetDocumentos: (state) => {
      state.data = [];
      state.error = null;
      state.currentPatientId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentosByPatientId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDocumentosByPatientId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.currentPatientId = action.meta.arg;
      })
      .addCase(getDocumentosByPatientId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al cargar los documentos del paciente"
        };
        state.data = [];
        state.currentPatientId = null;
      })
      //Crea el Documento
      .addCase(createDocumento.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createDocumento.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data.unshift(action.payload);
      })
      .addCase(createDocumento.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Fallo al crear el documento",
        };
      })
      // Casos para deleteDocumento
      .addCase(deleteDocumento.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteDocumento.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = state.data.filter(doc => doc.id !== action.payload);
      })
      .addCase(deleteDocumento.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || {
          message: "Error al eliminar el documento"
        };
      });
  }
});

export const { resetDocumentos } = documentosSlice.actions;
export default documentosSlice.reducer;